<script setup>
import { publicConfig } from '@/config/runtime'

defineProps({
    isSignUp: {
        type: Boolean,
        default: false,
    },
})

const socialBaseUrl = `${publicConfig().apiBaseUrl}v3/auth/oauth/`

const signupWithSocial = social => {
    window.location.href = `${socialBaseUrl}${social}`
}
</script>

<template>
    <div class="social-signup">
        <BaseButton
            class="button-social"
            variant="secondary"
            size="l"
            fill
            icon="logo-facebook"
            @click="signupWithSocial('facebook')"
        >
            {{ isSignUp ? 'Sign Up with' : 'Log In with' }} Facebook
        </BaseButton>
        <BaseButton
            class="button-social"
            variant="secondary"
            size="l"
            fill
            icon="logo-google"
            @click="signupWithSocial('google')"
        >
            {{ isSignUp ? 'Sign Up with' : 'Log In with' }} Google
        </BaseButton>
        <BaseButton
            class="button-social"
            variant="secondary"
            size="l"
            fill
            icon="logo-apple"
            @click="signupWithSocial('apple')"
        >
            {{ isSignUp ? 'Sign Up with' : 'Log In with' }} Apple
        </BaseButton>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.social-signup {
    margin-bottom: $s-m;
    .button-social {
        margin-bottom: $s-m;
    }
}
</style>
